import type { RouteObject } from "react-router-dom";
import SkillGroupClassDetail from "@/pages/skill/SkillGroupClassDetail";
import SkillGroupDetail from "@/pages/skill/SkillGroupDetail";
import SkillManagementDetail from "@/pages/skill/SkillManagementDetail";
import Skills from "@/pages/skill/Skills";
import SkillsManagement from "@/pages/skill/SkillsManagement";
import SkillsPlaza from "@/pages/skill/SkillsPlaza";
import SkillsPlazaDetail from "@/pages/skill/SkillsPlazaDetail";



// TODO(perf): lazy-load these non-first-screen pages with a shared, accessible Suspense fallback.
export const skillRoutes: RouteObject[] = [
  {
    path: "/plugins/skills",
    element:  <Skills />,
  },
  {
    path: "/plugins/skills/group-classes/:uid",
    element: <SkillGroupClassDetail />,
  },
  {
    path: "/plugins/skills/group-templates/:uid",
    element: <SkillGroupDetail />,
  },
  {
    path: "/plugins/skills/groups/:uid",
    element: <SkillGroupDetail />,
  },
  {
    path: "/plugins/skills/management",
    element: <SkillsManagement />,
  },
  {
    path: "/plugins/skills/management/:uid",
    element: <SkillManagementDetail />,
  },
  {
    path: "/plugins/skills/plaza",
    element: <SkillsPlaza />,
  },
  {
    path: "/plugins/skills/plaza/:uid",
    element: <SkillsPlazaDetail />,
  },
];
